import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appMultiSelectHeader]',
    standalone: false,
})
export class MultiSelectHeaderTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
    selector: '[appMultiSelectFooter]',
    standalone: false,
})
export class MultiSelectFooterTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

